// src/components/UI/Toast.js
import React, { useState, useEffect } from 'react';
import { Toast as BootstrapToast } from 'react-bootstrap';
import { create } from 'zustand';

// Store pro notifikace
export const useToastStore = create((set) => ({
    toasts: [],
    addToast: (message, variant = 'success', autoHide = true, delay = 5000) => {
        const id = Date.now();
        set((state) => ({
            toasts: [...state.toasts, { id, message, variant, autoHide, delay }]
        }));
        return id;
    },
    removeToast: (id) => {
        set((state) => ({
            toasts: state.toasts.filter((toast) => toast.id !== id)
        }));
    }
}));

// Komponenta pro zobrazení jednoho toastu
export const Toast = ({ id, message, variant, autoHide, delay, onClose }) => {
    const [show, setShow] = useState(true);

    useEffect(() => {
        if (autoHide) {
            const timer = setTimeout(() => {
                setShow(false);
                if (onClose) onClose(id);
            }, delay);
            return () => clearTimeout(timer);
        }
    }, [id, autoHide, delay, onClose]);

    const handleClose = () => {
        setShow(false);
        if (onClose) onClose(id);
    };

    const getIcon = () => {
        switch (variant) {
            case 'success':
                return <i className="fas fa-check-circle me-2"></i>;
            case 'danger':
                return <i className="fas fa-times-circle me-2"></i>;
            case 'warning':
                return <i className="fas fa-exclamation-triangle me-2"></i>;
            case 'info':
                return <i className="fas fa-info-circle me-2"></i>;
            default:
                return null;
        }
    };

    return (
        <BootstrapToast
            show={show}
            onClose={handleClose}
            delay={delay}
            autohide={autoHide}
            className="mb-3"
            bg={variant}
            text={variant === 'warning' ? 'dark' : 'white'}
        >
            <BootstrapToast.Header closeButton>
                {getIcon()}
                <strong className="me-auto">{variant === 'success' ? 'Úspěch' :
                    variant === 'danger' ? 'Chyba' :
                        variant === 'warning' ? 'Upozornění' : 'Informace'}</strong>
            </BootstrapToast.Header>
            <BootstrapToast.Body>
                {message}
            </BootstrapToast.Body>
        </BootstrapToast>
    );
};

// Kontejner pro všechny toasty
export const ToastContainer = () => {
    const { toasts, removeToast } = useToastStore();

    return (
        <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1050 }}>
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    id={toast.id}
                    message={toast.message}
                    variant={toast.variant}
                    autoHide={toast.autoHide}
                    delay={toast.delay}
                    onClose={removeToast}
                />
            ))}
        </div>
    );
};